import confirmModal from '../../../common/modals/ConfirmModal/confirmModal.component';
import addRoleModal from './modals/addRoleModal/addRoleModal.component';
import addPermissionsModal from './modals/addPermissionsModal/addPermissionsModal.component';
import editRoleModal from './modals/editRoleModal/editRoleModal.component';

const PROTECTED_ROLE_NAMES = ['USER', 'SUPERADMIN'];

class RoleManagementController {
  constructor($rootScope, $http, toastr, $scope, $uibModal) {
    "ngInject";
    this.name = 'roles';
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.toastr = toastr;
    this.$scope = $scope;
    this.$uibModal = $uibModal;
    let self = this;
    this.selectedRole = undefined;
    this.activeRoleTab = 0;
    this.rolesTableData = [];
    this.permissionsTableData = [];
    this.usersTableData = [];
    this.activeEmployeesForRole = [];
    this.addingAllPermissions = false;

    window.roleManagementCtrl = self;
    $scope.$on('$destroy', function () {
      if (window.roleManagementCtrl === self) {
        delete window.roleManagementCtrl;
      }
    });

    this.roleColumns = [
      {
        displayName: 'Display Text',
        value: 'displayText',
        sortable: true,
        formatting: function (record) {
          let html = '<strong class="role-name">' + (record.displayText || '') + '</strong>';
          if (record.roleDescription) {
            html += '<div class="role-meta">' + record.roleDescription + '</div>';
          }
          return html;
        },
        clickFunction: function (record) {
          self.selectRole(record._role);
        }
      },
      {
        displayName: 'Users',
        value: 'userCount',
        sortable: true,
        dataType: 'number',
        clickFunction: function (record) {
          self.selectRole(record._role);
        }
      }
    ];

    this.permissionColumns = [
      {
        displayName: 'Permission',
        value: 'displayName',
        sortable: true,
        formatting: function (record) {
          return record.displayName || record.name || '';
        }
      },
      {
        displayName: 'Description',
        value: 'description',
        sortable: true,
        formatting: function (record) {
          return record.description || '—';
        }
      },
      {
        displayName: 'Action',
        value: 'actions',
        sortable: false,
        formatting: function (record) {
          return '<button type="button" class="btn btn-xs btn-danger"' +
            ' onclick="event.stopPropagation(); window.roleManagementCtrl.removePermissionFromRoleById(' + record.id + ')"' +
            ' title="Remove permission from role">' +
            '<i class="fa fa-trash"></i> Remove</button>';
        }
      }
    ];

    this.userColumns = [
      {
        displayName: 'Name',
        value: 'fullName',
        sortable: true
      },
      {
        displayName: 'Status',
        value: 'statusLabel',
        sortable: true,
        sortValue: 'active',
        formatting: function (record) {
          if (record.active === false) {
            return '<span class="label label-warning">Inactive</span>';
          }
          return '<span class="label label-success">Active</span>';
        }
      },
      {
        displayName: 'Action',
        value: 'actions',
        sortable: false,
        formatting: function (record) {
          return '<button type="button" class="btn btn-xs btn-danger"' +
            ' onclick="event.stopPropagation(); window.roleManagementCtrl.removeUserFromRoleById(' + record.id + ')"' +
            ' title="Remove user from role">' +
            '<i class="fa fa-trash"></i> Remove</button>';
        }
      }
    ];

    $scope.$watch(function () {
      return self.roleFilter;
    }, function () {
      self.refreshRolesTableData();
    });

    $scope.$watch(function () {
      return self.roles;
    }, function () {
      self.refreshRolesTableData();
    }, true);

    this.$http.get($rootScope.apiHost + "/api/admin/roles", {withCredentials: true}).then(function (success) {
      self.roles = success.data;
      self.enrichRolesWithUserActiveStatus();
      self.refreshRolesTableData();
    });

    this.$http.get($rootScope.apiHost + "/api/admin/users/names", {withCredentials: true}).then(function (success) {
      self.employees = success.data;
      self.refreshActiveEmployeesForRole();
      self.enrichRolesWithUserActiveStatus();
      self.refreshRolesTableData();
      self.refreshDetailTables();
    });

    this.$http.get($rootScope.apiHost + "/api/admin/permissions", {withCredentials: true}).then(function (success) {
      self.permissions = success.data;
    });
  }

  enrichRolesWithUserActiveStatus() {
    if (!this.roles || !this.employees) {
      return;
    }

    const activeById = {};
    this.employees.forEach(function (employee) {
      activeById[employee.id] = employee.active;
    });

    this.roles.forEach(function (role) {
      (role.users || []).forEach(function (user) {
        if (activeById[user.id] !== undefined) {
          user.active = activeById[user.id];
        }
      });
    });
  }

  refreshActiveEmployeesForRole() {
    this.activeEmployeesForRole = (this.employees || []).filter(function (employee) {
      return employee.active !== false;
    });
  }

  isActiveUser(user) {
    return user && user.active !== false;
  }

  refreshRolesTableData() {
    this.enrichRolesWithUserActiveStatus();

    if (!this.roles) {
      this.rolesTableData = [];
      return;
    }

    const filter = (this.roleFilter || '').toLowerCase();
    this.rolesTableData = this.roles.filter(function (role) {
      if (!filter) {
        return true;
      }
      return (role.roleName && role.roleName.toLowerCase().indexOf(filter) !== -1) ||
        (role.roleDescription && role.roleDescription.toLowerCase().indexOf(filter) !== -1) ||
        (role.text && role.text.toLowerCase().indexOf(filter) !== -1);
    }).map(function (role) {
      return {
        id: role.id,
        roleName: role.roleName,
        roleDescription: role.roleDescription,
        displayText: role.text || role.roleName,
        userCount: (role.users || []).length,
        _role: role
      };
    });
  }

  refreshDetailTables() {
    this.enrichRolesWithUserActiveStatus();

    if (!this.selectedRole) {
      this.permissionsTableData = [];
      this.usersTableData = [];
      return;
    }

    this.permissionsTableData = (this.selectedRole.permissions || []).slice();
    this.usersTableData = (this.selectedRole.users || []).map(function (user) {
      return {
        id: user.id,
        fullName: user.firstName + ' ' + user.lastName,
        firstName: user.firstName,
        lastName: user.lastName,
        active: user.active,
        statusLabel: user.active === false ? 'Inactive' : 'Active',
        _user: user
      };
    });
  }

  isInactiveUser(user) {
    return user && user.active === false;
  }

  getInactiveUsersForRole(role) {
    if (!role || !role.users) {
      return [];
    }
    return role.users.filter(function (user) {
      return user.active === false;
    });
  }

  getAllInactiveRoleAssignments() {
    const assignments = [];

    (this.roles || []).forEach(function (role) {
      (role.users || []).forEach(function (user) {
        if (user.active === false) {
          assignments.push({
            roleId: role.id,
            roleName: role.roleName,
            user: user
          });
        }
      });
    });

    return assignments;
  }

  getInactiveRoleAssignmentCount() {
    return this.getAllInactiveRoleAssignments().length;
  }

  getInactiveRoleAssignmentRoleCount() {
    const roleIds = {};
    this.getAllInactiveRoleAssignments().forEach(function (assignment) {
      roleIds[assignment.roleId] = true;
    });
    return Object.keys(roleIds).length;
  }

  getUserRowClass(record) {
    if (record.active === false) {
      return 'role-management-inactive-user-row';
    }
    return '';
  }

  removeInactiveUsersFromRole(role) {
    let self = this;
    const inactiveUsers = this.getInactiveUsersForRole(role);

    if (!inactiveUsers.length) {
      return;
    }

    this.confirmAndRemoveInactiveUsers(
      'Remove Inactive Users from Role',
      role.roleName,
      'Remove all inactive users from the ' + role.roleName + ' role?',
      function () {
        return self.$http.delete(
          self.$rootScope.apiHost + '/api/admin/roles/' + role.id + '/users/inactive',
          {withCredentials: true}
        );
      }
    );
  }

  removeAllInactiveUsersFromRoles() {
    let self = this;
    const assignments = this.getAllInactiveRoleAssignments();
    const roleCount = this.getInactiveRoleAssignmentRoleCount();

    if (!assignments.length) {
      return;
    }

    this.confirmAndRemoveInactiveUsers(
      'Remove All Inactive Users',
      assignments.length + ' assignment' + (assignments.length === 1 ? '' : 's'),
      'Remove ' + assignments.length + ' inactive user assignment' +
        (assignments.length === 1 ? '' : 's') + ' across ' + roleCount + ' role' +
        (roleCount === 1 ? '' : 's') + '?',
      function () {
        return self.$http.delete(
          self.$rootScope.apiHost + '/api/admin/roles/users/inactive',
          {withCredentials: true}
        );
      }
    );
  }

  confirmAndRemoveInactiveUsers(title, subject, message, removeFn) {
    let self = this;

    if (this.removingInactiveUsers) {
      return;
    }

    const modalInstance = this.$uibModal.open(confirmModal);
    modalInstance.title = title;
    modalInstance.subject = subject;
    modalInstance.message = message;

    modalInstance.yes = function () {
      self.removingInactiveUsers = true;

      removeFn().then(function (success) {
        modalInstance.dismiss();
        self.roles = success.data;
        self.reSelectRole();
        self.removingInactiveUsers = false;
        self.toastr.success('Inactive users removed from role assignments.', 'Success!');
      }, function () {
        modalInstance.dismiss();
        self.removingInactiveUsers = false;
        self.toastr.error('Could not remove inactive users from roles.', 'Error');
      });
    };

    modalInstance.no = function () {
      modalInstance.dismiss();
    };
  }

  getRoleRowClass(record) {
    if (this.selectedRole && record._role && record._role.id === this.selectedRole.id) {
      return 'role-management-row-selected';
    }
    return '';
  }

  reSelectRole() {
    let self = this;
    if (!self.selectedRole) {
      return;
    }
    self.roles.forEach(function (role) {
      if (role.id === self.selectedRole.id) {
        self.selectedRole = role;
      }
    });
    self.refreshRolesTableData();
    self.refreshDetailTables();
  }

  selectRole(role) {
    this.selectedRole = role;
    this.activeRoleTab = 0;
    this.suser = null;
    this.selectedUser = null;
    this.refreshDetailTables();
    this.refreshRolesTableData();
  }

  isRoleNameEditable(role) {
    if (!role || !role.roleName) {
      return false;
    }
    return PROTECTED_ROLE_NAMES.indexOf(role.roleName.toUpperCase()) === -1;
  }

  isRoleDeletable(role) {
    if (!role || !role.roleName) {
      return false;
    }
    return PROTECTED_ROLE_NAMES.indexOf(role.roleName.toUpperCase()) === -1;
  }

  openEditRoleModal() {
    let self = this;

    if (!this.selectedRole) {
      return;
    }

    const modalInstance = this.$uibModal.open(editRoleModal);
    modalInstance.role = this.selectedRole;
    modalInstance.isNameEditable = this.isRoleNameEditable(this.selectedRole);

    modalInstance.result.then(function (roles) {
      if (roles) {
        self.roles = roles;
        self.reSelectRole();
      }
      self.toastr.success('Role updated successfully.', 'Success!');
    });
  }

  openAddRoleModal() {
    let self = this;
    const modalInstance = this.$uibModal.open(addRoleModal);

    modalInstance.result.then(function (roles) {
      self.roles = roles;
      self.refreshRolesTableData();
      self.toastr.success('Role created successfully.', 'Success!');
    });
  }

  openAddPermissionsModal() {
    let self = this;

    if (!this.selectedRole || !this.permissions) {
      return;
    }

    const availablePermissions = this.getUnassignedPermissions();
    if (!availablePermissions.length) {
      this.toastr.info('This role already has all available permissions.', 'Permissions');
      return;
    }

    const modalInstance = this.$uibModal.open(addPermissionsModal);
    modalInstance.role = this.selectedRole;
    modalInstance.availablePermissions = availablePermissions;

    modalInstance.result.then(function (roles) {
      self.roles = roles;
      self.reSelectRole();
      self.toastr.success('Permissions added to role.', 'Success!');
    });
  }

  getAssignedPermissionIds(role) {
    const assignedIds = {};
    ((role && role.permissions) || []).forEach(function (permission) {
      if (permission && permission.id != null) {
        assignedIds[String(permission.id)] = true;
      }
    });
    return assignedIds;
  }

  getUnassignedPermissions(role) {
    const targetRole = role || this.selectedRole;
    if (!targetRole || !this.permissions) {
      return [];
    }

    const assignedIds = this.getAssignedPermissionIds(targetRole);
    return this.permissions.filter(function (permission) {
      return permission && permission.id != null && !assignedIds[String(permission.id)];
    });
  }

  addAllPermissionsToRole() {
    let self = this;

    if (!this.selectedRole || this.addingAllPermissions) {
      return;
    }

    const unassigned = this.getUnassignedPermissions();
    if (!unassigned.length) {
      this.toastr.info('This role already has all available permissions.', 'Permissions');
      return;
    }

    this.addingAllPermissions = true;
    this.$http.post(
      this.$rootScope.apiHost + '/api/admin/roles/' + this.selectedRole.id + '/permissions/batch',
      { permissionIds: unassigned.map(function (permission) { return permission.id; }) },
      { withCredentials: true }
    ).then(function (success) {
      self.roles = success.data;
      self.reSelectRole();
      self.toastr.success('All permissions added to role.', 'Success!');
    }, function (failure) {
      const message = (failure.data && failure.data.message)
        ? failure.data.message
        : 'Could not add all permissions to this role.';
      self.toastr.error(message, 'Error');
    }).finally(function () {
      self.addingAllPermissions = false;
    });
  }

  removePermissionFromRoleById(permissionId) {
    if (!this.selectedRole || !this.selectedRole.permissions) {
      return;
    }
    const permission = this.selectedRole.permissions.find(function (p) {
      return p.id === permissionId;
    });
    if (permission) {
      this.removePermissionFromRole(this.selectedRole, permission);
    }
  }

  removeUserFromRoleById(userId) {
    if (!this.selectedRole || !this.selectedRole.users) {
      return;
    }
    const user = this.selectedRole.users.find(function (u) {
      return u.id === userId;
    });
    if (user) {
      this.removeUserFromRole(user, this.selectedRole);
    }
  }

  removePermissionFromRole(role, permission) {
    let self = this;

    this.$http.delete(this.$rootScope.apiHost + "/api/admin/roles/" + role.id + "/permissions/" + permission.id, {withCredentials: true}).then(function (success) {
      self.roles = success.data;
      self.reSelectRole();
      self.toastr.success("Permission Removed from Role.", "Success!");
    });
  }

  addUserToRole(user, role) {
    let self = this;
    if (!this.selectedUser) {
      return;
    }
    if (!this.isActiveUser(this.selectedUser)) {
      this.toastr.warning('Only active users can be assigned to a role.', 'Inactive User');
      this.selectedUser = null;
      this.suser = null;
      return;
    }
    this.$http.post(this.$rootScope.apiHost + "/api/admin/roles/" + this.selectedRole.id + "/users", this.selectedUser, {withCredentials: true}).then(function (success) {
      self.roles = success.data;
      self.reSelectRole();
      self.suser = null;
      self.selectedUser = null;
      self.toastr.success("User Added To Role.", "Success!");
    });
  }

  addAllUsersToRole(role) {
    let self = this;
    this.$http.post(this.$rootScope.apiHost + "/api/admin/roles/" + this.selectedRole.id + "/users/all?active=true", {}, {withCredentials: true}).then(function (success) {
      self.roles = success.data;
      self.reSelectRole();
      self.toastr.success("All active users added to role.", "Success!");
    });
  }

  removeAllUsersFromRole(role) {
    let self = this;

    if (!role || !role.users || !role.users.length) {
      return;
    }

    const modalInstance = this.$uibModal.open(confirmModal);
    modalInstance.title = 'Remove All Users';
    modalInstance.subject = role.roleName;
    modalInstance.message = 'Remove all ' + role.users.length + ' user' +
      (role.users.length === 1 ? '' : 's') + ' from the ' + role.roleName + ' role?';

    modalInstance.yes = function () {
      self.$http.delete(
        self.$rootScope.apiHost + '/api/admin/roles/' + role.id + '/users/all',
        {withCredentials: true}
      ).then(function (success) {
        modalInstance.dismiss();
        self.roles = success.data;
        self.reSelectRole();
        self.toastr.success('All users removed from role.', 'Success!');
      }, function () {
        modalInstance.dismiss();
        self.toastr.error('Could not remove all users from role.', 'Error');
      });
    };

    modalInstance.no = function () {
      modalInstance.dismiss();
    };
  }

  removeUserFromRole(user, role) {
    let self = this;
    this.$http.delete(this.$rootScope.apiHost + "/api/admin/roles/" + this.selectedRole.id + "/users/" + user.id, {withCredentials: true}).then(function (success) {
      self.roles = success.data;
      self.reSelectRole();
      self.toastr.success("User Removed from Role.", "Success!");
    });
  }

  selectUser(item) {
    if (!this.isActiveUser(item)) {
      this.toastr.warning('Only active users can be assigned to a role.', 'Inactive User');
      this.selectedUser = null;
      this.suser = null;
      return;
    }
    this.selectedUser = item;
  }

  deleteRole(role) {
    let self = this;

    if (!role || !this.isRoleDeletable(role)) {
      return;
    }

    const modalInstance = this.$uibModal.open(confirmModal);
    modalInstance.title = 'Delete Role';
    modalInstance.subject = role.roleName;
    modalInstance.message = 'Are you sure you want to delete this role? Users assigned to it will lose this role.';

    modalInstance.yes = function () {
      self.$http.delete(self.$rootScope.apiHost + '/api/admin/roles/' + role.id, {withCredentials: true}).then(function (success) {
        modalInstance.dismiss();
        if (success.data) {
          self.roles = success.data;
        } else {
          self.roles = (self.roles || []).filter(function (r) {
            return r.id !== role.id;
          });
        }
        if (self.selectedRole && self.selectedRole.id === role.id) {
          self.selectedRole = undefined;
          self.refreshDetailTables();
        }
        self.refreshRolesTableData();
        self.toastr.success('Role deleted successfully.', 'Success!');
      }, function () {
        modalInstance.dismiss();
        self.toastr.error('Could not delete role.', 'Error');
      });
    };

    modalInstance.no = function () {
      modalInstance.dismiss();
    };
  }
}

export default RoleManagementController;



// WEBPACK FOOTER //
// ./client/pages/admin/role-management/role-management.controller.js